/**
 * Component Entry
 *
 */

import Checkbox from './Checkbox'
export default Checkbox
export * from './Checkbox'
